module.exports = __webpack_public_path__ + "24e004ab/img/saly-icon.39e12342.jpg";